import { Component, Input, type OnDestroy, type OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import type { DisplayFile } from '../message.service';

@Component({
  selector: 'app-thread-file-upload-display',
  templateUrl: './thread-file-upload-display.component.html',
  styleUrls: ['./thread-file-upload-display.component.scss'],
  standalone: false,
})
export class DisplayFileUploadComponent implements OnInit, OnDestroy {
  @Input() displayFile: DisplayFile;

  fileName: string;
  showError = false;
  progressValue = 0;
  progressMode: 'determinate' | 'query' = 'determinate';
  fileFinalized = false;
  tempImage: string | undefined;
  statusObservable: Subject<'cancel' | 'remove'>;

  subscriptions = new Subscription();

  ngOnInit(): void {
    const {
      file,
      progressObservable,
      messageFileObservable,
      statusObservable,
    } = this.displayFile;

    if (
      file.type === 'image/png' ||
      file.type === 'image/gif' ||
      file.type === 'image/jpeg'
    ) {
      const reader = new FileReader();
      reader.addEventListener('load', (event) => {
        const r = event?.target?.result;
        if (r && typeof r === 'string') this.tempImage = r;
      });
      reader.readAsDataURL(file);
    }

    const progressSubscription = progressObservable.subscribe({
      next: (progress) => {
        this.progressValue = progress;
      },
      error: (error) => {
        this.showError = true;
      },
    });
    this.fileName = file.name;

    const messageFileSubscription = messageFileObservable.subscribe({
      next: (messageFile) => {
        this.fileFinalized = true;
        this.progressMode = 'determinate';
      },
      error: (err) => {
        this.showError = true;
        this.fileFinalized = true;
        this.progressMode = 'determinate';
      },
    });

    this.subscriptions.add(progressSubscription);
    this.subscriptions.add(messageFileSubscription);
  }

  clickCancel(): void {
    this.statusObservable.next('cancel');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
